/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Notitietype_Administratie3Inputs */

const nl_enums_notitietype_administratie3 = /** @type {(inputs: Enums_Notitietype_Administratie3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administratie`)
};

/**

* @param {Enums_Notitietype_Administratie3Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_notitietype_administratie3 = /** @type {((inputs?: Enums_Notitietype_Administratie3Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Notitietype_Administratie3Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_notitietype_administratie3(inputs)
});
export { enums_notitietype_administratie3 as "enums.NotitieType.Administratie" }